import React, { useEffect } from 'react';
import { Suspense, lazy } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';
import { useDashboards } from '../core/contexts/DashboardContext';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const DefaultDashboard = () => {
  const {currentDashboard} = useDashboards();
  const navigate = useNavigate();
  useEffect(() => {
    console.log("redirect to dashboard")
    navigate(currentDashboard?.tag!)
  }, [currentDashboard]);

  return (
    <div>
      <h1>Looking for the dashboard...</h1>
    </div>
  );
};


const baseRoutes = [
  {
    path: '/',
    element:  <DefaultDashboard />
  },
  {
    path: 'overview',
    element: <Navigate to="/" replace />
  },
  {
    path: '*',
    element: <Status404 />
  },
  {
    path: 'status',
    children: [
      {
        path: '500',
        element: <Status500 />
      },
      {
        path: 'maintenance',
        element: <StatusMaintenance />
      },
      {
        path: 'coming-soon',
        element: <StatusComingSoon />
      }
    ]
  },
  {
    path: '*',
    element: <Status404 />
  }
];

export default baseRoutes;
